import { AbstractControlOptions } from '@angular/forms';

import { applyMixins } from '@fry/lib/utils/mixin';

import { IsInheritable } from '../is-inheritable/is-inheritable.model';
import { EditorDataService } from '../editor-data/editor-data.service';


export abstract class EditorBookingItemSetting {
  abstract settingClassName: string;
  abstract serializedName: string;
  abstract showSummary: boolean;

  abstract createCopy();
  abstract getTitle(): string;
  abstract getHelpText(): string;
  abstract hasSummary(): boolean;
  abstract getFormConfig(editorData: EditorDataService): {
    controlsConfig: { [key: string]: any; },
    options?: AbstractControlOptions
  };
  abstract getFormValues(): any;
  abstract getEmptyFormValues(): any;
  abstract applyFormValues(formValues: any);
  abstract getSerializedValues(): any;

  protected constructor(obj?: any) {
    this.inheritableType = obj?.inheritableType ?? null;
  }

  createChild(): EditorBookingItemSetting {
    const setting = this.createCopy();
    setting.inheritableType = setting.getClonedInheritableTypeAsChild();
    return setting;
  }

  createComplete(parent: EditorBookingItemSetting): EditorBookingItemSetting {
    const setting = this.createCopy();
    setting.inheritableType = parent.getUserDefinedInheritableTypeAsChild(setting.inheritableType);
    return setting;
  }
}


// tslint:disable-next-line:no-empty-interface
export interface EditorBookingItemSetting extends IsInheritable {}
applyMixins(EditorBookingItemSetting, [IsInheritable]);
